import { Box, Chip, Stack, Typography } from '@mui/material';
import { FormFieldLabel } from 'src/components/Forms/FormFieldLabel/form-field-label';
import { SelectMenu, type SelectMenuOption } from 'src/components/SelectMenu';
import { SETTINGS_SECTION_ROW_PADDING } from 'src/components/SettingsSection';
import { mutedSx } from './styles';

interface CgCustomDomainSegmentsProps {
  brandIds: string[];
  isLive: boolean;
  options: SelectMenuOption[];
  onChange: (brandIds: string[]) => void;
}

export const CgCustomDomainSegments = ({
  brandIds,
  isLive,
  options,
  onChange,
}: CgCustomDomainSegmentsProps) => {
  const hint = getSegmentsHint(isLive, brandIds.length);

  return (
    <Box sx={SETTINGS_SECTION_ROW_PADDING}>
      <FormFieldLabel component="span">Client segments</FormFieldLabel>
      <SelectMenu
        multiple
        options={options}
        values={brandIds}
        onValuesChange={onChange}
        disabled={!isLive}
        placeholder="Choose the client segments served here"
        menuWidth="trigger"
        sx={{ width: '100%' }}
      />

      {brandIds.length ? (
        <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 1.5 }}>
          {brandIds.map((brandId) => (
            <Chip
              key={brandId}
              size="small"
              label={options.find(({ value }) => value === brandId)?.title ?? brandId}
              onDelete={() => onChange(brandIds.filter((id) => id !== brandId))}
            />
          ))}
        </Stack>
      ) : null}

      {hint ? (
        <Typography variant="body2" sx={{ ...mutedSx, mt: 1.5 }}>
          {hint}
        </Typography>
      ) : null}
    </Box>
  );
};

function getSegmentsHint(isLive: boolean, segmentCount: number): string | null {
  if (!isLive) return 'You can add client segments once the domain is live.';

  return segmentCount
    ? null
    : 'No client segments yet. Clients only reach this address once you add one.';
}
